




























































import { defineComponent } from "@vue/composition-api"

// hooks
import useGiftTask from "./useGiftTask"

// components
import GiftTaskItem from "./GiftTaskItem.vue"
import GiftTaskItemTab from "./GiftTaskItemTab.vue"
import Loading from "../Common/Loading.vue"

export default defineComponent({
  name: "GiftTask",
  components: {
    GiftTaskItem,
    GiftTaskItemTab,
    Loading
  },
  setup() {
    const giftTask = useGiftTask()
    return giftTask
  }
})
